// src/pages/NotFoundPage.tsx

import React from "react";
import { Link } from "react-router-dom";
import "../styles/NotFoundPage.css"; // Optional: Create and style this CSS file

const NotFoundPage: React.FC = () => {
  return (
    <div className="not-found-page">
      <h1>404 - Page Not Found</h1>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link to="/">Go Back Home</Link>
    </div>
  );
};

export default NotFoundPage;
